import self from "../img/self.png"
import mock1 from "../img/mock1.png"
import mock2 from "../img/mock2.png"
import mock3 from "../img/mock3.png"
import mock4 from "../img/mock4.png"
import mock5 from "../img/mock5.png"
import mock6 from "../img/mock6.png"
import mock7 from "../img/mock7.png"
import mock8 from "../img/mock8.png"
import mock9 from "../img/mock9.png"
import mock10 from "../img/mock10.png"
import mock11 from "../img/mock11.png"

/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];
/*
I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout
the site.
 */


/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

export const info = {
    firstName: "Andrew",
    lastName: "VanOver",
    initials: "av", // the example uses first and last, but feel free to use three or more if you like.
    position: "an aspiring Front End Developer",
    selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
    gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
    baseColor: colors[0],
    miniBio: [ // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
 {
            emoji: '☕',
            text: 'Tea connoisseur (:'
        },
        {
            emoji: '🌎',
            text: 'Based in the Netherlands'
        },
        {
            emoji: "💼",
            text: "Aspiring Front End Developer"
        },
        {
            emoji: "📧",
            text: "AndrewVanOverNL@gmail.com, resume below"
            
        }
    ],
    socials: [
 {
            link: "https://www.linkedin.com/in/andrew-v-37a98716a/",
            icon: "fa fa-linkedin",
            label: 'linkedin'
        }, 
  {
            link: "https://github.com/andrewvanovernl",
            icon: "fa fa-github",
            label: 'github'
        },
        {
            link: "https://drive.google.com/file/d/11ARQz97RAecYNT9lhL9A-QRANNmIZ434/view?usp=sharing",
            icon: "fa fa-clipboard",
            label: 'resume'
        }
        
        
// Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
// Just change the links so that they lead to your social profiles.

    ],
bio: "Through June-November 2022 I followed a HBO Bachelor in Front-End Development at Winc Academy, which focuses on HTML5, CSS3, JavaScript ES6+ and React JS. I am an aspiring developer!",
    skills:
        {
         proficientWith: ['javascript', 'react', 'git', 'github', 'html5', 'css3', 'figma','media queries', 'SASS', 'SCSS','API use','animations', 'bootstrap','nodejs', 'Framer-motion', 'AOS','TDD' ],
            exposedTo: [ 'redux', 'typescript', 'Vue', 'PHP','back end development','AWS']
        }
    ,
    hobbies: [
        {
            label: 'reading',
            emoji: '📖'
        },
        {
            label: 'Gyming',
            emoji: '🎭'
        },
        {
            label: 'movies',
            emoji: '🎥'
        },
        {
            label: 'cooking',
            emoji: '🌶'
        }
// Same as above, change the emojis to match / relate to your hobbies or interests.
// You can also remove the emojis if you'd like, I just think they look cute :P
    ],
    portfolio: [ // This is where your portfolio projects will be detailed
        
          {
            title: "Portfolio Landing page",
            live: "https://subtle-tapioca-8e00d2.netlify.app/",
            source: "https://github.com/andrewvanovernl/Portfolio-Landing-Page",
            image: mock11
        },
         {
            title: "Card Effect",
            live: "https://idyllic-capybara-cb2044.netlify.app/",
            source: "https://github.com/andrewvanovernl/Card-component-effect/tree/main",
            image: mock10
        },
        
        {
            title: "Clock",
            live: "https://superb-unicorn-13db56.netlify.app/",
            source: "https://github.com/andrewvanovernl/Simple-Clock",
            image: mock7
        },
         {
            title: "Art Landing page",
            live: "https://superb-lebkuchen-d9cdd0.netlify.app/",
            source: "https://github.com/andrewvanovernl/Art-landing-page-example",
            image: mock8
        },
        {
            title: "Matrix-Effect",
            live: "https://tourmaline-dragon-1e3b91.netlify.app/",
            source: "https://github.com/andrewvanovernl/Matrix-effect",
            image: mock9
        },
       {
            title: "Grocery list",
            live: "https://nimble-piroshki-89723e.netlify.app", //this should be a link to the live version of your project, think github pages, netlify, heroku, etc. Or your own domain, if you have it.
            source: "https://github.com/andrewvanovernl/Grocery-list", // this should be a link to the **repository** of the project, where the code is hosted.
            image: mock1
        },
        {
            title: "To do list",
            live: "https://silver-taffy-eef793.netlify.app/",
            source: "https://github.com/andrewvanovernl/Todo-List",
            image: mock2
        },
        {
            title: "Film finder",
            live: "https://majestic-creponne-187f01.netlify.app",
            source: "https://github.com/andrewvanovernl/film-finder",
            image: mock3
        },
        {
            title: "Meme generator",
            live: "https://sensational-crepe-bb70fd.netlify.app/",
            source: "https://github.com/andrewvanovernl/Meme-Generator",
            image: mock4
        },
        {
            title: "Dropdown menu",
            live: "https://bright-narwhal-59a6d3.netlify.app/",
            source: "https://github.com/andrewvanovernl/Dropdown-Menu-Color-Toggle",
            image: mock5
        },
         {
            title: "Gradient Generator",
            live: "https://astounding-cendol-db064d.netlify.app/",
            source: "https://github.com/andrewvanovernl/GradientGeneratie",
            image: mock6
        }
        
    ]
}
